import { stepperAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { ButtonLikePattern, TypographyPattern } from '../patterns';

// Styles
const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(stepperAnatomy.keys);

// Exports
export const Stepper = defineMultiStyleConfig({
  baseStyle: definePartsStyle((props) => ({
    stepper: {
      flexGrow: 1,
    },
    step: {
      '&[data-status="complete"] .chakra-icon': {
        color: ButtonLikePattern.variants.solid.static(props).color,
      },
      '&[data-status="active"] .chakra-icon': {
        color: ButtonLikePattern.variants.outline.static(props).color,
      },
      '&[data-status="incomplete"] .chakra-icon': {
        color: ButtonLikePattern.variants.outline.static({
          ...props,
          colorScheme: 'gray',
        }).color,
      },
    },
    title: {
      ...TypographyPattern.variants['button-text'],
    },
    description: {
      ...TypographyPattern.variants['detail-muted'],
    },
    indicator: {
      '&[data-status="complete"]': ButtonLikePattern.variants.solid.static(
        props,
      ),
      '&[data-status="active"]': ButtonLikePattern.variants.outline.static(
        props,
      ),
      '&[data-status="incomplete"]': ButtonLikePattern.variants.outline.static({
        ...props,
        colorScheme: 'gray',
      }),
    },
    separator: {
      bgColor: ButtonLikePattern.variants.solid.static({
        ...props,
        colorScheme: 'gray',
      }).bgColor,
      '&[data-status="complete"]': {
        bgColor: ButtonLikePattern.variants.solid.static(props).bgColor,
      },
      '&[data-orientation="horizontal"]': {
        alignSelf: 'flex-start',
        marginInlineStart: 0,
        marginTop: '1rem',
      },
    },
  })),
});
